<template>
    <div class="content" style="background-color: #fff;">
    	<div style="padding: .15rem .4rem;">
    		<div class="searchBar">
	            <div class="ckTime" style="width: auto;">
	                <span @click="timeStartShow=true" style="margin-left:0;"><font v-text="formatDate(timeStart)"></font><van-icon name="arrow-down" /></span>
	                <font style="line-height: .4rem;margin-left: .2rem;">至</font>
	                <span @click="timeEndShow=true"><font v-text="formatDate(timeEnd)"></font><van-icon name="arrow-down" /></span>
	            </div>
	        </div>
	        <div>
	        	<div class="table" style="margin-top: .3rem;">
					<div class="table-title">
                        <van-row type="flex">
                            <van-col span="8">日期</van-col>
                            <van-col span="6">累计消费金额</van-col>
                            <van-col span="6">累计通话时长</van-col>
                            <van-col span="4">操作</van-col>
                        </van-row>
                    </div>
                    <div class="table-body">
                        <van-row class="table-null" v-if="list2.length==0">未查询到数据</van-row>
                        <van-row type="flex" class="table-tr" v-for="(item,index) in list2" :key="index">
                            <van-col span="8">{{item.recordDate}}</van-col>
                            <van-col span="6">{{item.moneyTotal/100}}元</van-col>
                            <van-col span="6">{{item.durationTotalStr}}</van-col>
                            <van-col span="4"><font color="#02C702" @click="$router.push('/consumptionDesc?time='+item.recordDate)">详情</font></van-col>
                        </van-row>
                    </div>
				</div>
	        </div>
    	</div>
        <van-popup v-model="timeStartShow" position="bottom">
        	<van-datetime-picker v-model="timeStart" type="date" title="开始日期" :visible-item-count="3" @confirm="timeConfirm" @cancel="timeConfirm" />
        </van-popup>
        <van-popup v-model="timeEndShow" position="bottom">
        	<van-datetime-picker v-model="timeEnd" type="date" title="结束日期" :visible-item-count="3" @confirm="timeConfirm" @cancel="timeConfirm"/>
        </van-popup>
    </div>
</template>
<script type="text/javascript">
	import axios from 'axios';
    import {getOrganizationDetail,organizationAccountRecords,consumptionStatisticsList} from '../../api';
    export default {
        name: 'recharge',
        data() {
            return {
                timeStartShow:false,
                timeEndShow:false,
                statusShow:false,
                timeStart:new Date(this.getDate(-7)),
                timeEnd:new Date(this.getDate(0)),
                list2:[]
            }
        },
        methods: {
        	getDate(day){
				var setDate = new Date();
				setDate.setTime(setDate.getTime() + 3600 * 1000 * 24 * day);
				return setDate.getFullYear()+"/"+(setDate.getMonth()+1)+"/"+setDate.getDate();
			},
            formatDate(date) {
                return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
            },
            timeConfirm(v){
            	this.timeStartShow = false;
            	this.timeEndShow = false;
                this.consumptionStatisticsList();
            },
            consumptionStatisticsList(){
                consumptionStatisticsList({
                    orderType:2,
                    timeStart:this.formatDate(this.timeStart),
                    timeEnd:this.formatDate(this.timeEnd),
                }).then((res) => {
                    if(res.code==1){
                        this.list2 = res.data;
                    }else{
                        this.$toast("错误信息:"+res.message);
                    }
                })
            }
        },
        mounted(){
            this.consumptionStatisticsList();
    	}
	}
</script>


// WEBPACK FOOTER //
// src/views/order/consumptionList.vue


// WEBPACK FOOTER //
// src/views/order/consumptionList.vue